<script>
    // decision: [1]
    const {name, size = 24, width = null, height = null, class: cls = '', title = ''} = $props();
</script>

<svg
    width={width ?? size}
    height={height ?? size}
    fill="currentColor"
    class={cls}
    role={title ? 'img' : undefined}
    aria-label={title || undefined}
    aria-hidden={title ? undefined : 'true'}
    focusable="false"
><use xlink:href="#{name}"></use></svg>
